import { IHasFormStatus } from "@/api/dtos";
import { FormStatusType } from "@ngt/opms";

/**
 * Returns a readOnly callback for CrfForm that disallows editing when the
 * caller does not have update permission OR the form is locked.
 */
export const crfReadOnly = (canUpdate: boolean) =>
    (info: { initialValue?: any }): boolean =>
        !canUpdate || (info.initialValue as IHasFormStatus | undefined)?.formStatus == FormStatusType.Locked;
